import { GetFeatureFlagsDocument } from './generated/graphql';
import { makeQuery } from './make-query';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class FeatureFlagsQueries {
    constructor(http) {
        this.http = http;
        this.getFeatureFlags = (variables) => makeQuery({ http: this.http, operation: GetFeatureFlagsDocument, variables });
    }
}
FeatureFlagsQueries.ɵfac = function FeatureFlagsQueries_Factory(t) { return new (t || FeatureFlagsQueries)(i0.ɵɵinject(i1.HttpClient)); };
FeatureFlagsQueries.ɵprov = i0.ɵɵdefineInjectable({ token: FeatureFlagsQueries, factory: FeatureFlagsQueries.ɵfac, providedIn: 'root' });
//# sourceMappingURL=feature-flags.js.map